<template>
  <div class="bottom_list_wrap" :class="{ yincang_active: chunjing }">
    <!-- 底部5个按钮 -->
    <div class="count_wrap">
      <div class="swiper-container0">
        <div class="swiper-wrapper count_ul">
          <div
            class="swiper-slide count_li"
            v-for="(item, index) in countArr"
            :key="index"
            @click="countClick(item.name)"
          >
            <div class="count_block">
              <div class="count_name dp_fs_color">
                {{ item.name }}
              </div>
              <div
                style="
                  display: inline-block;
                  font-size: 36px;
                  margin-left: 10px;
                  vertical-align: top;
                "
              >
                |
              </div>
              <div class="count_num" v-if="item['data']">
                <p
                  class="count font_family_dis yel"
                  v-show="
                    item.name != '消防主机' && item.name != '巡检系统(NFC)'
                  "
                >
                  <span v-if="item['data'].offLine">{{
                    item["data"].offLine
                  }}</span>
                  <span v-else>0</span>
                </p>
                <p
                  :class="
                    item.name != '消防主机' && item.name != '巡检系统(NFC)'
                      ? 'count font_family_dis w62'
                      : 'count font_family_dis none'
                  "
                  :style="{
                    fontSize:
                      item.name == '消防主机' || item.name == '巡检系统(NFC)'
                        ? '22px'
                        : '',
                    marginTop:
                      item.name == '消防主机' || item.name == '巡检系统(NFC)'
                        ? '-2px'
                        : '',
                  }"
                >
                  <span
                    v-show="
                      item.name != '消防主机' && item.name != '巡检系统(NFC)'
                    "
                    >／</span
                  >
                  <span v-if="item['data'].total">{{
                    item["data"].total
                  }}</span>
                  <span v-else>0</span>
                </p>

                <div class="type_name">
                  <span
                    v-show="
                      item.name != '消防主机' && item.name != '巡检系统(NFC)'
                    "
                    >异常数/</span
                  ><span>总数</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="yujing_guzhang_lixian_layer"
      :style="{ bottom: arrList.length ? '262px' : 0 }"
    >
      <ul>
        <li
          v-for="(item, index) in yujing_guzhang_lixian_arr"
          :key="index"
          :class="item.type"
        >
          <img
            :src="close"
            alt=""
            class="close_btn"
            @click="closeYj(item)"
          /> <!-- v-if="item.orYj" -->
          <div class="line_wrap">
            <div class="line">
              <img :src="guang" alt="" />
            </div>
          </div>
          <div class="layer_arr_cont dp_fs_color">
            <p class="layer_arr_cont_tit">
              {{ item.data.title }}
            </p>
            <p class="cont_main_text">
              {{ item.data.companyName }}
            </p>
            <p class="cont_main_text">
              {{ item.data.time }} {{ item.data.tname }}
            </p>
            <p class="cont_main_text">
              {{ item.data.content }}
            </p>
            <p class="cont_main_text">
              {{ item.data.contactName }} {{ item.data.contactPhone }}
            </p>
          </div>
          <div class="line_wrap">
            <div class="line">
              <img :src="guang" alt="" />
            </div>
          </div>
        </li>
      </ul>
    </div>
    <ul class="map_right_bottom_list_wrap" :class="{ transX: chunjing }">
      <li
        v-for="(item, index) in right_tuli_arr"
        :key="index"
        @click="tuliClick(index)"
      >
        <img :src="marker0Img" alt="" v-if="index === 0" />
        <img :src="marker1Img" alt="" v-if="index === 1" />
        <img :src="marker2Img" alt="" v-if="index === 2" />
        <img :src="marker4Img" alt="" v-if="index === 3" />
        <img :src="marker5Img" alt="" v-if="index === 4" />
        <span>{{ item.text }}</span>
        <span>{{ item.num }}</span>
      </li>
    </ul>
    <div class="map_left_bottom_box" :class="{ transX2: chunjing,visibleHiddenBox: upDownState }">
      <div class="subtitle flex-space-between" @click="upDown">
        <span>
          <img src="@/assets/marker/subtitle-icon.png" alt="">
          <span>周边资源</span>
        </span>
        <img src="@/assets/marker/up-icon.png" alt="">
      </div>
      <ul class="map_right_bottom_list_wrap leftTu" :class="{ visibleHidden: !upDownState}">
        <li
          v-for="(item, index) in left_tuli_arr"
          :key="index" style="padding-left: 20px;position: relative;z-index: 1;"
          @click="mapRBClick(item)"
        >
          <img src="@/assets/marker/icon_churukou.png" alt="" v-if="index === 0" />
          <img src="@/assets/marker/icon_binan.png" alt="" v-if="index === 1" />
          <img src="@/assets/marker/icon_xiaofangzhan.png" alt="" v-if="index === 2" />
          <img src="@/assets/marker/icon_jiayouzhan.png" alt="" v-if="index === 3" />
          <img src="@/assets/marker/icon_shuiyuan.png" alt="" v-if="index === 4" />
          <img src="@/assets/marker/icon_xiangao.png" alt="" v-if="index === 5" />
          <img src="@/assets/marker/icon_weixianpin.png" alt="" v-if="index === 6" />
          <span>{{ item.text }}</span>
          <span>{{ item.num }}</span>
        </li>
      </ul>
    </div>
    <div class="option-wrap">
      <div class="bottom_top">
        <ul class="tab_bjyj" v-if="baoOrYu">
          <li
            :class="{ highlight: bjyjInd == index }"
            v-for="(item, index) in bjyjArr"
            :key="index"
            @click="timeType(index)"
          >
            {{ item }}
          </li>
        </ul>
        <div class="form-wrap">
          <!-- 时间筛选 -->
          日期:
          <DatePicker
            transfer
            :word-wrap="true"
            type="date"
            placeholder="选择日期"
            @on-change="timeSearch"
            format="yyyy-MM-dd"
            style="width: 130px; margin-right: 10px"
            :options="dateLimit"
            v-model="timeSelet"
          ></DatePicker>
          时间:
          <TimePicker
            format="HH:mm"
            type="timerange"
            placeholder="选择时间"
            @on-change="timeSearch1"
            style="width: 130px"
            v-model="timeSelet1"
          >
          </TimePicker>
          <Select
            v-model="sysTypeId"
            transfer
            :word-wrap="true"
            clearable
            placeholder="系统形式"
            style="width: 130px"
            @on-change="selectFn"
            filterable
            :disabled="beginTime ? false : true"
            v-if="bjyjInd"
          >
            <Option
              v-for="item in sysTypeArr"
              :value="item.value"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
      </div>
      <div class="table-wrap" :style="'height:' + (newH - 62) + 'px'">
        <div class="table-head">
          <table>
            <tr>
              <th width="5%">序号</th>
              <th width="15%">单位</th>
              <th width="15%">事件</th>
              <th width="24%">状态</th>
              <th width="15%">时间</th>
              <th width="6%"></th>
            </tr>
          </table>
        </div>
        <div class="table-body" id="tableBody">
          <table>
            <tr
              v-for="(item, index) in arrList"
              :key="index"
              @click="setMarker(item, index)"
            >
              <td width="5%">
                {{ index + 1 }}
              </td>
              <td width="15%">
                <Poptip
                  trigger="hover"
                  transfer
                  :word-wrap="true"
                  :content="item.orgName"
                  v-if="item.orgName"
                >
                  {{ item.orgName }}
                </Poptip>
              </td>
              <td width="15%">
                <Poptip
                  trigger="hover"
                  transfer
                  :word-wrap="true"
                  :content="item.content"
                  v-if="item.content"
                >
                  {{ item.content }}
                </Poptip>
              </td>
              <td width="24%" class="status">
                <div class="block">
                  <span
                    :class="[
                      item.state == 0 || item.state == 1
                        ? 'red'
                        : item.state == 3
                        ? 'yellow'
                        : item.state == 2
                        ? 'green'
                        : '',
                    ]"
                  ></span
                  ><span
                    :class="[
                      item.state == 3
                        ? 'yellow'
                        : item.state == 2
                        ? 'green'
                        : '',
                    ]"
                  ></span
                  ><span :class="{ green: item.state == 2 }"></span>
                </div>
                <div class="status_text">
                  <div
                    class="text_block"
                    v-if="item.state == 0 || item.state == 1"
                  >
                    <span :class="{ red: item.state == 0 || item.state == 1 }">
                      未处理
                    </span>
                    <img
                      :src="red"
                      alt=""
                      v-if="item.state == 0 || item.state == 1"
                    />
                  </div>
                  <div class="text_block" v-if="item.state == 3">
                    <span :class="{ yellow: item.state == 3 }"> 处理中 </span>
                    <img :src="yellow" alt="" v-if="item.state == 3" />
                  </div>
                  <div class="text_block" v-if="item.state == 2">
                    <span :class="{ green: item.state == 2 }"> 已处理 </span>
                    <img :src="green" alt="" v-if="item.state == 2" />
                  </div>
                </div>
              </td>
              <td width="15%">
                {{ item.ctime == undefined ? "" : timestampToTime(item.ctime) }}
              </td>
              <td v-show="bjyjInd == 0 && item.gatewayType==4" width="6%">
                <span @click.stop="openPasswordModel(item)"
                  ><i
                    class="iconfont icon-kongzhitai"
                    style="margin-right: 5px"
                  ></i
                  >控制</span
                >
              </td>
            </tr>
          </table>

          <div class="ani_wrap jysTyle" v-show="jystatus">
            <img :src="tableLoad" style="width: 20%" />
          </div>
          <p
            class="no-data"
            :class="{ hide_svg: !jystatus }"
            v-show="arrList.length == 0 && !jystatus"
          >
            <img :src="noData_img" alt="" />
          </p>
        </div>
      </div>
    </div>

    <audio :src="tc_audio" autoplay="autoplay" loop="loop" ref="audio"></audio>

    <audio :src="bd_audio" autoplay="autoplay" loop="loop" ref="audio"></audio>
    <BottomListDetail
      ref="bottomListDetailRef"
      :eventInfo="eventInfo"
      :isShowPanel="isShowPanel"
      @closePanel="closePanel"
      @setOpenPasswordModel="openPasswordModel"
      @upDataList="selectFn"
      v-if="isShowPanel"
    ></BottomListDetail>
    <Modal
      v-model="passwordModal"
      title="验证密码"
      :closable="false"
      :mask-closable="false"
      class-name="show-password"
    >
      <Form ref="formInline" :model="formInline" :rules="ruleInline">
        <FormItem prop="password" label="请输入密码">
          <Input
            type="password"
            v-model="formInline.password"
            placeholder="请输入密码"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button
          @click="passwordCancel"
          style="background-color: rgba(231, 231, 231, 0.2); color: #fff"
          >取消</Button
        >
        <Button
          @click="passwordModalSubmit"
          type="primary"
          style="background-color: #0256ff"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import tc_audio from "@/assets/audio/tanchuang.mp3";
import guang from "@/assets/img/head-guang.png";
import tanchuang_img from "@/assets/img/tanchuang.png";
import noData_img from "@/assets/img/wubaojing.png";

import redImg from "@/assets/img/red_ico.png";
import yellowImg from "@/assets/img/yellow_ico.png";
import greenImg from "@/assets/img/green_ico.png";

import leftListVue from "./leftList.vue";

import close from "@/assets/img/close.png";
import CryptoJS from "../assets/js/core.js";
var SHA256 = require("../assets/js/sha256.js");

//获取右下角图例接口
import {
  bottom_mid,
  bottom_right,bottom_left,
  tuli_click,
  danweiList_click,
  layer_data,
  device_stat,
} from "@/assets/js/url.js";

import {  get_voice_broadcast } from "@/assets/js/bdaudio.js";
import marker0Img from "@/assets/marker/ico0.png"; //火警
import marker1Img from "@/assets/marker/ico1.png"; //报警
import marker2Img from "@/assets/marker/ico2.png"; //故障
import marker3Img from "@/assets/marker/ico3.png"; //正常
import marker4Img from "@/assets/marker/ico4.png"; //离线
import marker5Img from "@/assets/marker/ico5.png"; //预警

import tableLoad from "@/assets/img/animation.gif";
import BottomListDetail from "./bottomListDetail.vue";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import tanchuang_mp3 from "@/assets/audio/tanchuang.mp3";

const validatePass = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入密码"));
  } else {
    let password = CryptoJS.SHA256(value).toString();
    if (window.localStorage.getItem("hashValue") == password) {
      callback();
    } else {
      callback(new Error("密码错误"));
    }
  }
};
export default {
  name: "",
  data: () => ({
    jystatus: true,
    isShowPanel: false,
    eventInfo: {},
    tableLoad,
    tuli_click_index: 0,
    timeSelet: "", //日期
    timeSelet1: [], //时间
    sysTypeArr: [],
    sysTypeId: "",
    marker0Img,
    marker1Img,
    marker2Img,
    marker3Img,
    marker4Img,
    marker5Img,
    close,
    bjyjArr: ["火警信息", "报警信息", "预警信息", "故障信息"],
    bjyjInd: 0,
    baoOrYu: true,
    tc_audioNew: tanchuang_mp3,
    countArr: [
      {
        name: "消防主机",
        data: {},
      },
      {
        name: "智慧用电",
        data: {},
      },
      {
        name: "消防水系统",
        data: {},
      },
      {
        name: "独立式探测器",
        data: {},
      },
      {
        name: "自动灭火系统",
        data: {},
      },
      {
        name: "智能空开",
        data: {},
      },
      {
        name: "巡检系统(NFC)",
        data: {},
      },
      {
        name: "视频监控",
        data: {},
      },
      {
        name: "传输装置",
        data: {},
      },
    ],
    count_timer: null,
    count_timer1: null,
    bd_audio: "", //百度语音
    bd_audio_init: "", //初始化百度语音
    tc_audio: "", // 直接初始化为音频文件
    guang: guang,
    tc_img: tanchuang_img,
    noData_img: noData_img,
    right_tuli_arr: [
      {
        text: "火警单位",
        num: 0,
      },
      {
        text: "报警单位",
        num: 0,
      },
      {
        text: "故障单位",
        num: 0,
      },
      {
        text: "未联网单位",
        num: 0,
      },
      {
        text: "预警单位",
        num: 0,
      },
    ],
    left_tuli_arr: [
      {
        text: "出入口",
        num: 0,
        type: 4,
      },
      {
        text: "避难地",
        num: 0,
        type: 5,
      },
      {
        text: "微型消防站",
        num: 0,
        type: 7,
      },
      {
        text: "加油站",
        num: 0,
        type: 2,
      },
      {
        text: "周边水源",
        num: 0,
        type: 3,
      },
      {
        text: "限高杆",
        num: 0,
        type: 6,
      },
      {
        text: "危险品",
        num: 0,
        type: 1,
      },
    ],
    red: redImg,
    yellow: yellowImg,
    green: greenImg,
    arrList: [],
    loginData: "",
    yujing_guzhang_lixian_arr: [],
    bottom_song_option: true,
    baojing_init_currentPage: 1, //第一次进来报警列表当前页
    bot_right_tuli_click_index: 0, //中间右下角图例点击索引
    gzCurrent: 1,
    dateTime: "",
    beginTime: "",
    endTime: "",
    timeBegin: "",
    timeEnd: "",
    dateLimit: {
      disabledDate(date) {
        return date && date.valueOf() > Date.now();
      },
    },
    screeningDate: null,
    newH: 0,
    passwordModal: false, //密码
    formInline: {
      password: "",
    },
    ruleInline: {
      password: [{ required: true, validator: validatePass, trigger: "blur" }],
    },
    activeItem: {},
    mySwiper: null,
    upDownState: true,
  }),
  props: [
    "chunjing",
    "show_bot_trueData",
    "bot_song_status",
    "click_get_data",
    "yuInfo",
  ],
  watch: {
    chunjing: function (res) {
      // console.log(res);
    },
    show_bot_trueData: function (res) {
      // 关闭弹窗也会调用，显示原来的真实数据，
      // 点击单位名称也会调用，显示单位数据
      this.arrList = [];
      if (res.id) {
        this.screeningDate = res;
      } else {
        this.screeningDate = null;
      }
      this.arrList = [];
        this.baojing_init_currentPage = 1;
      this.getHjListData();
    },
    click_get_data: function (res) {
        this.arrList = [];
        this.baojing_init_currentPage = 1;
    },
    yujing_guzhang_lixian_arr: function (newVal, oldVal) {
      if (newVal.length == 0) {
        this.tc_audio = "";
        this.bd_audio = "";
      }
    },
    bot_song_status: function (res) {
      console.log(res.type);

      console.log("预警弹窗声音开关");
      this.bottom_song_option = res.type;

      if (res.type && this.yujing_guzhang_lixian_arr.length > 0) {
        //打开声音
        this.tc_audio = this.tc_audioNew;

        this.bd_audio = this.bd_audio_init;
      } else {
        //关闭声音
        this.tc_audio = "";

        this.bd_audio = "";
      }
    },
    yuInfo: function (res) {
      let that = this;
      res.time = that.timestampToTime(res.alarmTime);
      res.tname = res.deviceName;
      res.contactName = res.chargeName;
      res.contactPhone = res.chargeTel;
      res.title = res.typeName;
      console.log(res);
      let obj1 = {
        data: res,
        type: "yujing_tc",
        orYj: true,
      };
      that.yujing_guzhang_lixian_arr.unshift(obj1);
    },
  },
  components: { BottomListDetail },
  created() {
    this.loginData = JSON.parse(window.localStorage.getItem("loginData"));
    this.getSysType();
    this.$nextTick(() => {
      this.newH =
        document.getElementsByClassName("left-right_list_li")[0].clientHeight;
    });
    // this.getMqttUrl()
  },
  computed: {},
  mounted() {
    //获取图例数据
    this.getTuliData();

    //获取火警列表数据
    this.getHjListData();

    //获取下面5个数字块
    this.getCountData();
    let path = "web/c/5/";
    let c_id = JSON.parse(window.localStorage.getItem("loginData")).orgId;
    // //报警
    let baojing = path + c_id + "/100";
    //预警
    let yujing = path + c_id + "/101";
    //故障
    let guzhang = path + c_id + "/102";
    //离线
    let lixian = path + c_id + "/103";
    //火警
    let huojing = path + c_id + "/107";
    let that = this;
    //报警
    console.log(that.$mqtt, "1111111111");
    that.$mqtt.subscribe(baojing, (message) => {
      let obj = message.toString();
      console.log("推送接收报警", JSON.parse(obj));
      let data = JSON.parse(obj);
      let cid = data.id.split("_")[0];

      let type = "";
      if (data.type == "107") {
        //火警
        type = "4";
      } else if (data.type == "100") {
        //报警
        type = "2";
      } else if (data.type == "101") {
        //预警
        type = "1";
      } else if (data.type == "102") {
        //故障
        type = "3";
      }
      // 先打开弹框
      that.tanchuang_layer(0, data);
      setTimeout(() => {
        that.getVideoDetail(cid, type, data.uuid).then((res) => {
          data.cameras = res.data.cameras;
          data.mapPosition = res.data.mapPosition;
          data.mapPositionCrt = res.data.mapPositionCrt;
          data.content = res.data.content;
          // 渲染弹框中的数据
          that.tanchuang_layer(0, data, true);
        });
      }, 1000);
    });

    //预警
    that.$mqtt.subscribe(yujing, (message) => {
      let obj = message.toString();
      console.log("推送接收预警", JSON.parse(obj));
      let data = JSON.parse(obj);
      that.tanchuang_layer(1, data);
    });

    //故障
    that.$mqtt.subscribe(guzhang, (message) => {
      let obj = message.toString();
      console.log("推送接收故障", JSON.parse(obj));
      let data = JSON.parse(obj);
      that.tanchuang_layer(2, data);
    });

    //离线
    that.$mqtt.subscribe(lixian, (message) => {
      let obj = message.toString();
      console.log("推送接收离线", JSON.parse(obj));
      let data = JSON.parse(obj);
      that.tanchuang_layer(3, data);
    });

    //火警
    that.$mqtt.subscribe(huojing, (message) => {
      let obj = message.toString();
      console.log("推送接收火警", JSON.parse(obj));
      let data = JSON.parse(obj);
      let cid = data.id.split("_")[0];
      let type = "";
      if (data.type == "107") {
        //火警
        type = "4";
      } else if (data.type == "100") {
        //报警
        type = "2";
      } else if (data.type == "101") {
        //预警
        type = "1";
      } else if (data.type == "102") {
        //故障
        type = "3";
      }
      // 先打开弹框
      that.tanchuang_layer(4, data);
      setTimeout(() => {
        that.getVideoDetail(cid, type, data.uuid).then((res) => {
          console.log(622, res);
          data.cameras = res.data.cameras;
          data.mapPosition = res.data.mapPosition;
          data.mapPositionCrt = res.data.mapPositionCrt;
          data.content = res.data.content;
          // 渲染弹框中的数据
          that.tanchuang_layer(4, data, true);
        });
      }, 1000);
    });
  },
  methods: {
    // getMqttUrl() {
    //             return new Promise((resolve, reject) => {
    //                 var data = {
    //                     type: "get",
    //                     url: "/mcbw/file/template_static",
    //                     obj: {
    //                         fileKey:"oss_domain"
    //                     },
    //                 };
    //                 this.$Axios(data)
    //                 .then((res) => {
    //                     if (res.data.success&&res.data.data) {
    //                         this.tc_audioNew="http://"+res.data.data+"/gd-ca/tanchuang.mp3"
    //                     }
    //                 })
    //             });
    //         },
    getVideoDetail(cid, type, uid) {
      return new Promise((resolve, reject) => {
        let dataObj = {
          type: "get",
          url: "/mcbw/alarm_stats/alarm_detail",
          obj: { cid: cid, _id: uid, eventType: type },
        };
        this.$Axios(dataObj).then((res) => {
          console.log(686, res);
          if (res.data.success) {
            resolve(res.data);
          }
        });
      });
    },
    countClick(name) {
      //底部7个块点击事件
      console.log(name);
      let obj = {
        status: true,
        type: "midBot",
        navIndex: name,
      };
      this.$store.commit("showLayer", obj);
    },
    getSysType() {
      let dataObj = {
        type: "get",
        url: "/mcbw/dictionary_datas/systemForm/data",
        obj: {
          pageSize: 1000,
          currentPage: 1,
        },
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("系统形式");
        if (res.data.success) {
          this.sysTypeArr = res.data.data;
        }
      });
    },
    selectFn() {
      this.timeType(this.bjyjInd, "search");
    },
    returnTimeStamp(date) {
      return new Date(date).getTime();
    },
    timeSearch(res) {
      if (this.timeSelet) {
        let date = new Date(this.timeSelet)
          .toLocaleDateString()
          .replace(/\//g, "-");
        this.dateTime = date;
        this.beginTime = this.returnTimeStamp(date + " 00:00:00");
        this.endTime = this.returnTimeStamp(date + " 23:59:59");
        if (this.timeSelet1[0]) {
          this.beginTime = this.returnTimeStamp(date + " " + this.timeBegin);
          this.endTime = this.returnTimeStamp(date + " " + this.timeEnd);
        }
      } else {
        this.beginTime = "";
        this.endTime = "";
        this.timeSelet1 = [];
        this.beginTime = "";
        this.endTime = "";
      }

      console.log(!!this.beginTime);
      this.timeType(this.bjyjInd, "search");
    },
    timeSearch1() {
      if (this.timeSelet) {
        this.beginTime = this.returnTimeStamp(this.dateTime + " 00:00:00");
        this.endTime = this.returnTimeStamp(this.dateTime + " 23:59:59");
        if (this.timeSelet1[0]) {
          this.timeBegin = this.timeSelet1[0] + ":00";
          this.timeEnd = this.timeSelet1[1] + ":00";

          this.beginTime = this.returnTimeStamp(
            this.dateTime + " " + this.timeBegin
          );
          this.endTime = this.returnTimeStamp(
            this.dateTime + " " + this.timeEnd
          );
        }
      } else {
        this.beginTime = "";
        this.endTime = "";
      }
      this.timeType(this.bjyjInd, "search");
    },
    closeYj(obj) {
      this.yujing_guzhang_lixian_arr.forEach((item, index) => {
        if (item.data.alarmTime == obj.data.alarmTime) {
          this.yujing_guzhang_lixian_arr.splice(index, 1);
        }
      });
    },

    timeType(index, searchType = "") {
      //切换报警数据和预警数据
      if (!searchType) {
        // 切换时，清空查询条件
        this.sysTypeId = "";
        this.timeSelet = "";
        this.timeSelet1 = [];
        this.dateTime = "";
        this.beginTime = "";
        this.endTime = "";
        this.timeBegin = "";
        this.timeEnd = "";
      }
      this.bjyjInd = index;
      this.baojing_init_currentPage = 1;
      console.log("5555", this.bjyjInd);
      console.log(this.arrList);

      this.arrList = [];
      this.getHjListData();
    },
    getCountData() {
      //底部5个块
      clearInterval(this.count_timer);
      clearTimeout(this.count_timer1);
      let dataObj = {
        type: "get",
        url: "/mcbw/device_statistic/device_stat",
        obj: {
          orgId: this.loginData.orgId,
        },
      };
      this.$Axios(dataObj)
        .then((res) => {
          console.log(res);
          console.log("底部5个块");
          if (res.data.success) {
            this.countArr[0] = {
              name: "消防主机",
              data: res.data.data["xfhost"],
            }; //消防主机
            this.countArr[1] = {
              name: "电气火灾监控",
              data: res.data.data["zhyd"],
            }; //智慧用电
            this.countArr[2] = {
              name: "消防水系统",
              data: res.data.data["xfys"],
            }; //消防水
            this.countArr[3] = {
              name: "独立式探测器",
              data: res.data.data["xfzj"],
            }; //独立式探测器
            this.countArr[4] = {
              name: "自动灭火系统",
              data: res.data.data["zdmh"],
            }; //自动灭火系统
            this.countArr[5] = {
              name: "智能空开",
              data: res.data.data["znkk"],
            }; //智能空开
            this.countArr[6] = {
              name: "巡检系统(NFC)",
              data: res.data.data["nfc"],
            }; //巡检
            this.countArr[7] = {
              name: "视频监控",
              data: res.data.data["ksh"],
            }; //摄像头
            this.countArr[8] = {
              name: "传输装置",
              data: res.data.data["cszz"],
            }; //传输装置
          }
          this.$nextTick(() => {
            this.countArr = JSON.parse(JSON.stringify(this.countArr));
            this.mySwiper = new Swiper(".swiper-container0", {
              autoplay: {
                delay: 3000,
                stopOnLastSlide: false,
                disableOnInteraction: false,
              },
              slidesPerView: 5,
              loop: false,
            });
            // this.count_timer = setInterval(() => {
            // $(".count_ul").addClass("trans");
            // this.count_timer1 = setTimeout(() => {
            //   this.countArr.push(this.countArr.shift());
            //   this.countArr.push(this.countArr.shift());
            //   $(".count_ul").removeClass("trans");
            // }, 2000);
            // }, 7000);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    animation(obj) {
      //动画
      var params = {
        container: document.getElementById(obj),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: this.$aniData,
      };
      var anim;
      anim = lottie.loadAnimation(params);
    },
    timestampToTime(timestamp) {
      if (timestamp == undefined) {
        return "";
      } else {
        var date = new Date(timestamp); //时间戳 -- 如果date为13位不需要乘1000  3-11修改
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        var h =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
          ":";
        var m =
          (date.getMinutes() < 10
            ? "0" + date.getMinutes()
            : date.getMinutes()) + ":";
        var s =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
      }
    },
    //预警、故障、离线弹窗管理
    //显示15秒后自动消失，不能手动关闭
    //1.预警、故障、离线
    tanchuang_layer(type, data, isUpdate) {
      //四个状态每次触发，都会重新获取一下图例数据
      if (!isUpdate) {
        console.log("重新获取图例信息");
        this.getTuliData();
      }
      switch (type) {
        case 0: //报警
          // 如果当前选中了报警，需要重新请求报警列表，否则不请求
          if (this.bjyjInd == 1 && !isUpdate) {
            console.log("这里又重新调取一下获取报警信息列表接口");
            $(".list_wrap ul").css("transform", "translateX(0)");
            this.baojing_init_currentPage = 1;
            this.arrList = [];
            this.getHjListData();
          }
          let ops = {
            data: data,
          };
          this.$emit("baojing_tanchuang", ops);
          break;
        case 1: //预警
          let obj1 = {
            data: data,
            type: "yujing_tc",
          };
          this.yujing_guzhang_lixian_arr.unshift(obj1);
          setTimeout(() => {
            // this.yujing_guzhang_lixian_arr.shift(obj1);
            this.yujing_guzhang_lixian_arr.pop();
            this.yujing_guzhang_lixian_option(
              this.yujing_guzhang_lixian_arr.length
            );
          }, 15000);
          break;
        case 2: //故障
          $(".list_wrap ul").css("transform", "translateX(0)");
          let obj2 = {
            data: data,
            type: "guzhang_tc",
          };
          this.yujing_guzhang_lixian_arr.unshift(obj2);
          setTimeout(() => {
            // this.yujing_guzhang_lixian_arr.shift(obj2);
            this.yujing_guzhang_lixian_arr.pop();
            // this.yujing_guzhang_lixian_option(
            //   this.yujing_guzhang_lixian_arr.length
            // );
          }, 15000);
          break;
        case 3: //离线
          let obj3 = {
            data: data,
            type: "lixian_tc",
          };
          this.yujing_guzhang_lixian_arr.unshift(obj3);
          setTimeout(() => {
            // this.yujing_guzhang_lixian_arr.shift(obj3);
            this.yujing_guzhang_lixian_arr.pop();
            this.yujing_guzhang_lixian_option(
              this.yujing_guzhang_lixian_arr.length
            );
          }, 15000);
          break;
        case 4: //火警
          // 如果当前选中了火警，需要重新请求火警列表，否则不请求
          if (this.bjyjInd == 0 && !isUpdate) {
            console.log("这里又重新调取一下获取火警信息列表接口");
            $(".list_wrap ul").css("transform", "translateX(0)");
            this.baojing_init_currentPage = 1;
            this.getHjListData();
          }

          let ops_hj = {
            data: data,
            type: "hj",
          };
          this.$emit("baojing_tanchuang", ops_hj);
          break;
      }
      //每次接收数据都会判断一下当前是否有声音了
      if (( type == 1 || type == 2 || type == 3 ) && this.bottom_song_option) {
        this.tc_audio = this.tc_audioNew;
        console.log(data);
        this.bd_audio = "";
        this.bd_audio_init = "";
        get_voice_broadcast(data.content).then((res) => {
          this.bd_audio_init = res && res.data ? res.data.trim() : "";
          this.bd_audio = this.bd_audio_init;
        });
      }
      // if(type == 2){
      //   this.tc_audio =''
      //   this.bd_audio = "";
      //   this.bd_audio_init = "";
      // }
    },
    //控制声音,这里是15秒后消失后判断声音
    yujing_guzhang_lixian_option(num,type) {
      // console.log(num);
      // console.log(this.bottom_song_option);

      if ((type == 1||type==3) &&num && this.bottom_song_option) {
        //如果有还有数据，并且声音开关是打开的，则继续播放声音
        //打开声音
        this.tc_audio = this.tc_audioNew;
        this.bd_audio = this.bd_audio_init;
        
      } else {
        //关闭声音
        this.tc_audio = "";
        this.bd_audio = "";
      }
    },

    getTuliData() {
      console.log(8989);
      var orgId = this.loginData.orgId;
      var data = {
        type: "get",
        url: bottom_right,
        obj: { orgId: orgId },
      };
      this.$Axios(data)
        .then((res) => {
          this.right_tuli_arr[0].num = res.data.data.flamingFireCount||'~';
          this.right_tuli_arr[1].num = res.data.data.alarmCount||'~';
          this.right_tuli_arr[2].num = res.data.data.faultCount||'~';
          this.right_tuli_arr[3].num = res.data.data.offLineCount||'~';
          this.right_tuli_arr[4].num = res.data.data.warnCount||'~';
        })
       var data = {
        type: "get",
        url: bottom_left,
        obj: { orgId: orgId },
      };
      this.$Axios(data)
        .then((res) => {
          this.left_tuli_arr[0].num = res.data.data.emergencyExitCount||'~';
          this.left_tuli_arr[1].num = res.data.data.refugeAreaCount||'~';
          this.left_tuli_arr[2].num = res.data.data.miniFireStationCount||'~';
          this.left_tuli_arr[3].num = res.data.data.gasStationCount||'~';
          this.left_tuli_arr[4].num = res.data.data.vicinityWatersourceCount||'~';
          this.left_tuli_arr[5].num = res.data.data.heightLimitCount||'~';
          this.left_tuli_arr[6].num = res.data.data.dangerousGoodsCount||'~';
        })
    },
    getHjListData(type) {
      //火警信息列表
      if (type == "1") {
        this.jystatus = false;
      } else {
        this.jystatus = true;
      }
      console.log("pppp", this.bjyjInd);
      console.log(this.screeningDate);
      let data = {};
      if (this.screeningDate) {
        data = {
          type: "get",
          url: "/mcbw/dep_stats/dep_event_detail",
          obj: {
            eventType: this.tuli_click_index,
            currentPage: this.baojing_init_currentPage,
            pageSize: 20,
            states: "0,1,3",
            orgId: this.screeningDate.id,
          },
        };
      } else {
        let orgId = this.loginData.orgId;
        data = {
          type: "get",
          url: "",
          obj: {
            currentPage: this.baojing_init_currentPage,
            pageSize: 20,
            orgId: orgId,
            systemForm: this.sysTypeId ? this.sysTypeId : null,
            beginTime: this.beginTime ? this.beginTime : null,
            endTime: this.endTime ? this.endTime : null,
          },
        };
        if (this.bjyjInd == 0 || this.bjyjInd == 1) {
          data.url = "/mcbw/alarm_stats";
        }
        if (this.bjyjInd == 2 || this.bjyjInd == 3) {
          data.url = "/mcbw/dep_stats/dep_event_detail";
        }
        if (this.bjyjInd == 0) {
          data.obj["sources"] = "3,6,7";
        }
        if (this.bjyjInd == 2) {
          data.obj["eventType"] = "1";
        }
        if (this.bjyjInd == 3) {
          data.obj["eventType"] = "3";
        }
      }
      this.$Axios(data)
        .then((res) => {
          this.jystatus = false;
          console.log(res);
          console.log("数据列表数据");
          if (!res.data.data.length) {
            return;
          }
          this.arrList = [...this.arrList, ...res.data.data];
          let _this = this;
          this.$nextTick(() => {
            $JQ("#tableBody").mCustomScrollbar({
              callbacks: {
                onTotalScroll: function () {
                  if (
                    _this.arrList.length == res.data.totalCount ||
                    res.data.data.length == 0
                  ) {
                    console.log("没有更多数据");
                    return;
                  } else {
                    console.log("加载更多");
                    _this.baojing_init_currentPage += 1;
                    _this.getHjListData("1");
                  }
                },
              },
            });
          });
        })
        .catch(() => {
          this.jystatus = false;
          console.log("火警数据列表失败");
        });
    },
    tuliClick(index) {
      this.screeningDate = null;
      switch (index) {
        case 0:
          this.tuli_click_index = 6; // 火警单位
          this.baoOrYu = true;
          this.timeType(0);
          break;
        case 1:
          this.tuli_click_index = 2; // 报警单位
          this.baoOrYu = true;
          this.timeType(1);
          break;
        case 2:
          this.tuli_click_index = 3; //故障单位
          this.baoOrYu = true;
          this.timeType(3);
          break;
        case 3:
          this.tuli_click_index = 4; //未联网单位
          this.baoOrYu = false;
          break;
        case 4:
          this.tuli_click_index = 1; //预警单位
          this.baoOrYu = true;
          this.timeType(2);
          break;
      }

      this.$emit("companyStatus", this.tuli_click_index);
      this.bot_right_tuli_click_index = this.tuli_click_index;
    },
    setMarker(data, index) {
      let ops = {
        data: data,
        index: index,
        date: new Date(),
        baoOrYu: this.bjyjInd,
      };
      this.eventInfo = ops;
      this.isShowPanel = true;
      // this.$emit("markerStatus", ops);
    },
    closePanel(val) {
      this.isShowPanel = val;
    },
    upDown() {//周边资源伸缩
      this.upDownState = !this.upDownState;
    },
    mapRBClick(activeItem) { //点击周边资源行
      this.$emit("map-r-b-click", activeItem);
    },
    openPasswordModel(activeItem) {
      this.activeTableObj = activeItem;
      this.passwordModal = true;
    },
    passwordCancel() {
      this.$refs.formInline.resetFields();
      this.passwordModal = false;
    },
    passwordModalSubmit() {
      this.$refs.formInline.validate((result) => {
        if (result) {
          this.passwordCancel();
          // 通知bottomListDetail组件隐藏视频模块
          if(this.$refs.bottomListDetailRef){
            this.$refs.bottomListDetailRef.hideVideoModule();
          }
          this.$emit("upDate", this.activeTableObj);
          //点击事件
          // let params = {
          //   deviceNum: "",
          //   type: 20,
          //   passWord: CryptoJS.SHA256(this.formInline.password).toString(),
          // };
          // return new Promise((resolve, reject) => {
          //   this.$Axios({
          //       url: `/mcbw/network_monitor/switch_control`,
          //       type: "get",
          //       obj: { params },
          //     })
          //     .then((res) => {
          //       if (res.success) {
          //         this.$Message.success(res.message);
          //         this.passwordModal = false;
          //       }
          //       resolve();
          //     })
          //     .catch((err) => {
          //       console.log(err);
          //       reject(err);
          //     });
          // });
        }
      });
    },
    consoleClosed() {
      // 通知bottomListDetail组件控制台已关闭
      this.$refs.bottomListDetailRef && this.$refs.bottomListDetailRef.consoleClosed();
    },
    closePanel(val) {
      this.isShowPanel = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.bottom_list_wrap {
  position: absolute;
  bottom: 8px;
  left: 500px;
  color: #fff;
  width: calc(100% - 1000px);
  transition: all 1s;
  transform: translateY(0);
  z-index: 11;
  // mqtt 弹窗样式（除了报警）

  .count_wrap {
    //color:#00eff3;
    position: absolute;
    top: -86px;
    left: 0px;
    height: 91px;
    /*width: calc(100% - 126px);*/
    width: 100%;
    overflow: hidden;
    z-index: 1;
    .count_li {
      flex-shrink: 0;
      display: block;
      box-sizing: border-box;
      /*width: 23%;*/
      width: 20%;
      cursor: pointer;
      div.count_block {
        background: rgba(6, 18, 44, 0.8) url("../assets/img/bot_block.png")
          center center/100% 100% no-repeat;
        width: 180px;
        height: 70px;
        margin: 0 auto;
        font-size: 13px;
        padding: 8px 0;
        text-align: right;
        display: flex;
        justify-content: center;
        align-items: center;
        p:nth-child(1) {
          font-size: 15px;
        }
        p.yel {
          color: #dc4f4f;
          width: 47px;
          text-align: right;
        }
        .count_name {
          width: 38px;
          // height: 55px;
          padding-bottom: 2px;
          // vertical-align: middle;
          //vertical-align: top;
          //height: 100%;
          // vertical-align: super;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .count_num {
          text-align: center;
          width: 110px;
          height: 55.5px;
          position: relative;
          padding-top: 8px;
          p {
            font-weight: bolder;
            float: left;
          }
        }
        .count_name,
        .count_num {
          display: inline-block;
        }
        .type_name {
          width: 100%;
          overflow: hidden;
          text-align: center;
          margin-top: 4px;
        }
      }
    }
  }
  .count {
    //float: right;
    font-size: 12px;
    //margin-top: 15px;
  }
  .none {
    width: 100%;
    text-align: center;
  }
  .w62 {
    width: 63px;
    margin-top: 2px;
    text-align: left;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    display: -webkit-box;
    -webkit-line-clamp: 1; // 超出多少行
    -webkit-box-orient: vertical;
    word-break: keep-all; /* 不换行 */
    white-space: nowrap; /* 不换行 */
  }
  .yujing_guzhang_lixian_layer {
    position: absolute;
    left: 8px;
    bottom: 262px;
    transition: all 1s;
    overflow: hidden;
    z-index: 2;
    li {
      width: 360px;
      height: 216px;
      // background: url('../assets/img/tanchuang.png') no-repeat center;
      margin-top: 10px;
      overflow: hidden;
      position: relative;
      .close_btn {
        position: absolute;
        right: 0;
        top: 0;
        width: 10px;
        padding: 10px;
        cursor: pointer;
        box-sizing: content-box;
      }
      &.yujing_tc {
        // background-color: rgba(254, 103, 44, .3);
        background: url("../assets/img/yg.png") no-repeat center;
      }
      &.guzhang_tc {
        // background-color: rgba(234, 236, 44, .3);
        background: url("../assets/img/gz.png") no-repeat center;
      }
      &.lixian_tc {
        // background-color: rgba(194, 194, 194, .3);
        background: url("../assets/img/lx.png") no-repeat center;
      }
    }
    li:first-child {
      margin-top: 0;
    }
    .layer_arr_cont {
      width: 300px;
      height: 160px;
      margin: 0 auto;
      overflow: hidden;
      // color: #8effff;
      text-align: justify;
      padding-left: 10px;
      box-sizing: border-box;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-box-pack: center;
      .layer_arr_cont_tit {
        font-size: 16px;
        line-height: 30px;
      }
      .cont_main_text {
        font-size: 14px;
        line-height: 26px;
      }
    }
    .line_wrap {
      padding: 0 50px;
      margin-top: 25px;
      .line {
        height: 2px;
        background: #8effff;
        position: relative;
        img {
          position: absolute;
          top: -27px;
          left: -50px;
          width: 100px;
          height: 56px;
          transform: translateX(0px);
          animation: line_move1 3.75s linear infinite alternate;
          animation-fill-mode: forwards;
        }
      }
    }
    .line_wrap:last-child {
      margin-top: 0;
      .line img {
        left: initial;
        right: -50px;
        animation: line_move2 3.75s linear infinite alternate;
        animation-fill-mode: forwards;
      }
    }

    @keyframes line_move1 {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(260px);
      }
    }
    @keyframes line_move2 {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-260px);
      }
    }
  }
  .map_left_bottom_box {
    width: 170px;
    background-color: rgba(4, 39, 76, 0.4);
    position: absolute;
    left: 0;
    top:-338px;
    transition: all 1s;
    .subtitle {
      background-image: url("../assets/marker/subtitle-bg.png");
      background-repeat: no-repeat;
      height: 36px;
      background-size: 100% 100%;
      padding: 0 10px;
      line-height: 36px;
      cursor: pointer;
      > span {
        img {
          margin-right: 5px;
          width: 16px;
          height: 24px;
          display: inline-block;
          vertical-align: middle;
          margin-top: 2px;
        }
      }
      > img {
        width: 18px;
        height: 18px;
      }
    }
  }
  .visibleHidden {
    height: 210px;
  }
  .visibleHiddenBox {
    top:-135px;
  }
  .map_right_bottom_list_wrap {
    position: absolute;
    right: 0;
    top: -254px;
    transition: all 1s;
    li {
      overflow: hidden;
      font-size: 0;
      margin: 10px 0;
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        height: 20px;
        margin-right: 10px;
      }
      span {
        display: block;
        font-size: 14px;
      }
      span:nth-child(2) {
        width: 75px;
        text-align: left;
      }
    }
    li:nth-child(1) {
      span:first-child {
        background: #e22525;
      }
    }
    li:nth-child(2) {
      span:first-child {
        background: #eaec2c;
      }
    }
    li:nth-child(3) {
      span:first-child {
        background: #c2c2c2;
      }
    }
    li:nth-child(4) {
      span:first-child {
        background: #fe672c;
      }
    }
  }
  .tit {
    margin-left: 8px;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    // color: #00e6eb;
    // border-bottom: 1px solid #00e6eb;
    // border-image: linear-gradient(to right, rgba(0, 239, 243, 1) 0%, rgba(0, 0, 0, 0) 50%) 30 30;
    background: linear-gradient(
      to right,
      rgba(4, 58, 94, 1) 0%,
      rgba(0, 0, 0, 0) 50%
    );
  }
  .option-wrap {
    padding: 10px;
    background: rgba(6, 18, 44, 1) url("../assets/img/maskBg.png") center
      center/101% 101% no-repeat;
    .table-wrap {
      height: 187px !important;
      display: flex;
      flex-direction: column;
      .table-head {
        background: #0c2745;
        color: #7db4db;
        table th {
          height: 30px;
        }
      }
      .table-body {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        color: #e4eff5;
        /deep/ .mCSB_scrollTools {
          right: 0 !important;
          .mCSB_dragger {
            background: rgba(255, 255, 255, 0.3);
            border-radius: 8px;
            .mCSB_dragger_bar {
              width: 8px;
            }
          }
          .mCSB_draggerRail {
            background-color: transparent;
          }
        }
        table td {
          text-align: center;
          height: 30px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          i {
            cursor: pointer;
          }
          i.imgView {
            color: rgba(8, 244, 247, 0.7);
            cursor: pointer;
            &.active {
              color: rgba(8, 244, 247, 0.3);
              cursor: default;
            }
          }
          .td-option-wrap {
            display: flex;
            align-items: center;
            justify-content: center;
            i {
              margin: 0 10px;
              color: rgba(8, 244, 247, 0.3);
              cursor: default;
              &.active {
                color: rgba(8, 244, 247, 0.7);
                cursor: pointer;
              }
            }
          }
        }
        table tr {
          height: 45px;
          cursor: pointer;
        }
        table tr:nth-child(2n) {
          background: #0c2745;
        }
        .no-data {
          width: 170px;
          margin: 30px auto;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ddd;
          img {
            width: 100%;
          }
        }
        .status {
          .block {
            display: inline-block;
            width: 60%;
            height: 10px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 50px;
            overflow: hidden;
            span {
              float: left;
              height: 100%;
              width: calc(100% / 3);
            }
            span.red {
              background: #ff6c65;
            }
            span.yellow {
              background: #01dbdf;
            }
            span.green {
              background: #09f4a6;
            }
          }
          .status_text {
            vertical-align: inherit;
            display: inline-block;
            overflow: hidden;
            text-indent: 25px;
            .text_block {
              height: 35px;
              float: left;
              // width: calc(100% / 3);
              display: -webkit-box;
              -webkit-box-orient: horizontal;
              -webkit-box-align: center;
              -webkit-box-pack: center;
              span.red {
                color: #ff6c65;
              }
              span.yellow {
                color: #01dbdf;
              }
              span.green {
                color: #09f4a6;
              }
              img {
                margin-left: 8px;
              }
            }
          }
        }
      }

      table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
      }
    }
  }
  .bottom_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .tab_bjyj {
    li {
      display: inline-block;
      padding: 0 10px;
      position: relative;
      font-size: 14px;
      cursor: pointer;
      &::after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 15px;
        vertical-align: top;
        position: absolute;
        right: 0;
        top: 2.5px;
      }
      &.active {
        opacity: 1;
      }
    }
    .highlight {
      color: #74d9ff;
      border-bottom: 2px solid #74d9ff;
    }
    /*.highlight::before{*/
    /*  content: "";*/
    /*  display: block;*/
    /*  position: absolute;*/
    /*  width: 35px;*/
    /*  right: 4px;*/
    /*  bottom: 0px;*/
    /*  border-bottom: 4px solid #74d9ff;*/
    /*}*/
  }
}
.yincang_active {
  transform: translateY(calc(100% + 20px));
  .map_right_bottom_list_wrap {
    right: -5%;
  }
}
.transX {
  transform: translateX(400px);
}
.transX2 {
  transform: translateX(-400px);
}
.noData_wrap {
  height: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  img {
    width: 150px;
  }
}
/deep/ .ivu-select-disabled .ivu-select-selection {
  background-color: #041936;
  color: #c5c8ce;
  border: 1px solid #1b314b;
}
/deep/ .ivu-select-single .ivu-select-input {
  color: #00eef3;
}
.jysTyle {
  position: fixed;
  top: 25%;
}
/deep/ .show-password {
  .ivu-modal-content {
    background-color: #041936;
    box-shadow: inset 0px 0px 30px 0px rgba(62, 117, 190, 0.5);
    .ivu-modal-header {
      border-bottom: 1px solid #979797;
      .ivu-modal-header-inner {
        color: #eef2f4;
      }
    }
    .ivu-form-item-label {
      color: #74d9ff;
    }
    .ivu-input {
      background: rgba(255, 255, 255, 0.2);
      box-sizing: border-box;
      border: 1px solid #596c87;
      color: #74d9ff;
    }
  }
  .ivu-modal-body {
    padding-top: 15px;
    .show-table-header {
      border-left: 2px solid #02e7e7;
      margin-left: 15px;
      padding-left: 10px;
      .table-header-desc {
        font-size: 18px;
        color: #02e7e7;
      }
      /deep/ .close-btn {
        float: right;
        margin-right: 20px;
        border: 1px solid #08f4f7;
        color: #08f4f7;
        width: 56px;
        height: 28px;
        line-height: 28px;
        cursor: pointer;
        outline: none;
        border-color: rgba(8, 244, 247, 0.3);
        background-color: hsla(0, 0%, 100%, 0.1);
      }
    }
  }
  .ivu-modal-footer {
    border-color: #979797;
  }
}
.leftTu{
  // left:0;top:-403px;width: 170px;
  height: 0;
  position: initial !important;
  overflow: hidden;
    li {
      margin: 8px 0 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/bottomList.vue